import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormTextArea from './FormTextArea.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function MessageSysadminNew({showNew, closeNew, updateMessageRowNew}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [note, setNote] = useState('');
	const [noteError, setNoteError] = useState('');

	const noteRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showNew, popupAnimationMs);

	useEffect(() => {
		setNote('');
	}, [showNew]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNoteError('');

		let localError = 0;

		if (!note) {
			localError = 1;
			setNoteError('povinné');
			noteRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveMessageNew', {NOTE: note})
				.then((res) => {
					if (res.ID > 0) {
						updateMessageRowNew({ID: res.ID, CRDTS: res.CRDTS, NOTE: note, NOTES: res.NOTES, READ_CNT: 0});
					}

					closeNew();

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Nová zráva</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeNew();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormTextArea type="text" label="Zpráva" height="25rem" value={note} setValue={setNote} ref={noteRef} error={noteError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeNew();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
